import { getTextFieldManifestStyleFields } from './manifest-styles.ts';

const manifest = {
  plugin_id: 4012,
  api: {},
  dependency_repository_url: [],
  dependency_name: '@applicaster/quick-brick-component-text-field',
  author_name: 'Applicaster',
  author_email: 'zapp@applicaster.com',
  name: 'Form Text Field',
  description: 'Text input component for Quick Brick form screens.',
  type: 'ui_component',
  screen: false,
  react_native: true,
  identifier: 'quick-brick-component-text-field',
  ui_builder_support: true,
  whitelisted_account_ids: [],
  deprecated_since_zapp_sdk: '',
  unsupported_since_zapp_sdk: '',
  targets: ['web'],
  ui_frameworks: ['quickbrick'],
  platform: 'web',
  dependency_version: '0.1.0-alpha.21',
  manifest_version: '0.1.0-alpha.24',
  min_zapp_sdk: '0.0.1',
  data: {
    fields: [
      { key: 'field_id', type: 'text_input', label: 'Field Id' },
      {
        key: 'input_type',
        type: 'select',
        label: 'Input type',
        label_tooltip:
          'Free text, a number, or a date entered through a locale-aware mask. Each type raises the matching keyboard; in date mode the component reports an ISO 8601 value (YYYY-MM-DD). quick-brick-screen-form validates the value in every mode.',
        options: [
          { text: 'Text', value: 'string' },
          { text: 'Number', value: 'number' },
          { text: 'Date', value: 'date' },
        ],
        initial_value: 'string',
      },
    ],
  },
  rules: { fields: [] },
  localizations: {
    fields: [
      {
        key: 'required_label',
        label: 'Required label',
        type: 'text_input',
        initial_value: '* Required',
      },
      {
        key: 'open_calendar_label',
        label: 'Open calendar label',
        type: 'text_input',
        initial_value: 'Open calendar',
      },
      {
        key: 'show_password_label',
        label: 'Show password label',
        type: 'text_input',
        initial_value: 'Show password',
      },
      {
        key: 'hide_password_label',
        label: 'Hide password label',
        type: 'text_input',
        initial_value: 'Hide password',
      },
    ],
  },
  styles: { fields: getTextFieldManifestStyleFields() },
  characteristics: {
    group: false,
    appearance: ['group', 'screen'],
    disable_default_cell_style: true,
  },
} as const;

export default manifest;
